export default __webpack_public_path__ + "static/blue-9c41444e4a4755002f2172d67d646d53.png";